import StoreSalesReportManagementLayout from "./StoreSalesReportManagementLayout";

export default StoreSalesReportManagementLayout;
